import { IUpdateVenueChannelsBody } from 'src/api/updateVenueChannels';
import { IChannelValues } from 'src/types/venueForm.types';

const channelsPayload = (data: IChannelValues): IUpdateVenueChannelsBody => {
  const obj = Object.keys(data);
  const channels = {};
  obj.forEach((channelId) => {
    channels[channelId] = {
      external_brand_id: data[channelId].externalBrandId || null,
      external_id: data[channelId].externalId || null,
      pk_venue_external_identifier_id: data[channelId].pkVenueExternalIdentifierId || null,
    };
  });

  return channels;
};

export default channelsPayload;
